const store = {
    namespaced: true,
    state() {
        return {
            isOpen: false,
            tabs: ['menu', 'catalog'],
            activeTab: 'menu'
        }
    },
    getters: {
        getIsOpen: (state) => state.isOpen,
        getTabs: (state) => state.tabs,
        getActiveTab: (state) => state.activeTab,
    },
    mutations: {
        SET_IS_OPEN: (state, flag) => state.isOpen = flag,
        SET_ACTIVE_TAB: (state, tab) => state.activeTab = tab,
    },
    actions: {
        setIsOpen: ({ commit }, flag) => commit('SET_IS_OPEN', flag),
        setActiveTab: ({ commit, state }, tab) => {
            if (state.tabs.includes(tab)) {
                commit('SET_ACTIVE_TAB', tab)
            }
            else{
                throw new Error(`Unvalid tab name from: [${tabs}]`)
            }
        },
        openCatalog: ({ dispatch }) => {
            dispatch('setActiveTab', 'catalog')
            dispatch('setIsOpen', true)
        },
    }
}

export default store